import type { ReactNode } from 'react'

import { CollectionList } from '@ds/components'

import styles from './FeaturedInSection.module.css'

export type TFeaturedInItem = {
    key: string
    content: ReactNode
}

type TFeaturedInSectionProps = {
    title: string
    items: TFeaturedInItem[]
}

export const FeaturedInSection = ({ title, items }: TFeaturedInSectionProps) => (
    <section className={styles.section}>
        <h2 className={styles.title}>{title}</h2>
        <CollectionList>
            {items.map(item => (
                <li key={item.key}>{item.content}</li>
            ))}
        </CollectionList>
    </section>
)
